const namePattern = /^[\p{L}\s-]+$/u;
const nicknameStartsWithPattern = /^[\d-_]/;
const nicknameContainsPattern = /[^a-zA-Z0-9-_]/;
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const minNameLength = 3;
const minNicknameLength = 6;
const minPasswordLength = 8;

const passwordRequirements = {
  minLength: `Mínimo ${minPasswordLength} caracteres`,
  uppercase: "Al menos una letra mayúscula",
  lowercase: "Al menos una letra minúscula",
  number: "Al menos un número",
  specialChar: "Al menos un carácter especial"
};

export const integerPattern = /^$|^[0-9]+$/;
export const oneDecimalPattern = /^$|^[0-9]+(,[0-9]?)?$/;
export const twoDecimalsPattern = /^$|^[0-9]+(,[0-9]{0,2})?$/;

export const NumberType = {
  Integer: "integer",
  OneDecimal: "oneDecimal",
  TwoDecimals: "twoDecimals"
};

export const validateName = (firstName, lastName, errors) => {
  const lengthErrorMessage = `Debe contener al menos ${minNameLength} caracteres`;
  if (firstName.length < minNameLength) {
    errors.firstName = lengthErrorMessage;
  }
  if (lastName.length < minNameLength) {
    errors.lastName = lengthErrorMessage;
  }

  const charsErrorMessage = "No puede contener números ni caracteres especiales";
  if (!namePattern.test(firstName)) {
    errors.firstName = charsErrorMessage;
  }
  if (!namePattern.test(lastName)) {
    errors.lastName = charsErrorMessage;
  }
};

export const validateNickname = (nickname, errors) => {
  if (nickname.length < minNicknameLength) {
    errors.nickname = `Debe contener al menos ${minNicknameLength} caracteres`;
  }
  if (nicknameStartsWithPattern.test(nickname)) {
    errors.nickname = "No puede comenzar con un número, guion o guion bajo";
  }
  if (nicknameContainsPattern.test(nickname)) {
    errors.nickname = "No puede contener caracteres especiales distintos a guion y guion bajo";
  }
};

export const validateEmail = (email, confirmEmail, errors) => {
  if (!emailPattern.test(email)) {
    errors.email = "Correo electrónico no válido";
  }

  if (email !== confirmEmail) {
    errors.confirmEmail = "Los correos electrónicos no coinciden";
  }
};

export const validatePassword = (password, confirmPassword) => {
  if (password.length < minPasswordLength) {
    return `La contraseña debe tener al menos ${minPasswordLength} caracteres`;
  }
  if (password !== confirmPassword) {
    return "Las contraseñas no coinciden";
  }
  return null;
};

export const getPasswordRequirements = (errorMessage) => {
  if (!errorMessage) {
    return Object.values(passwordRequirements);
  }

  const requirements = [];
  if (errorMessage.includes(`must contain at least ${minPasswordLength} characters`)) {
    requirements.push(passwordRequirements.minLength);
  }
  if (errorMessage.includes("must contain an upper case character")) {
    requirements.push(passwordRequirements.uppercase);
  }
  if (errorMessage.includes("must contain a lower case character")) {
    requirements.push(passwordRequirements.lowercase);
  }
  if (errorMessage.includes("must contain a numeric character")) {
    requirements.push(passwordRequirements.number);
  }
  if (errorMessage.includes("must contain a non-alphanumeric character")) {
    requirements.push(passwordRequirements.specialChar);
  }
  return requirements;
};

export const validateDate = (dateString, fieldName, minDate, errors) => {
  const date = new Date(dateString);

  if (date < new Date(minDate)) {
    errors[fieldName] = `Fecha debe ser posterior a ${new Date(minDate).toLocaleDateString("es-ES")}`;
  }

  const maxDate = new Date().toISOString().split("T")[0];
  if (date > new Date(maxDate)) {
    errors[fieldName] = `Fecha debe ser anterior a la fecha de hoy`;
  }
};

export const validateDatesEquivalence = (dateOfBirth, diseaseOnsetDate, errors) => {
  if (dateOfBirth.length > 0 && diseaseOnsetDate.length > 0 && dateOfBirth === diseaseOnsetDate) {
    errors.diseaseOnsetDate = "La fecha de inicio de la enfermedad no puede ser igual a la fecha de nacimiento";
  }
};

export const validateRequiredFields = (fields, formData, errors) => {
  fields.forEach(field => validateRequiredField(field, formData, errors));
};

export const validateRequiredField = (field, formData, errors) => {
  // Skip validation for readOnly fields
  if (field.readOnly) return;

  // Check if the field has a dependency
  if (field.dependency) {
    const dependentValue = formData[field.dependency.field];
    if (dependentValue !== field.dependency.value) {
      return; // Skip validation if the dependency condition is not met
    }
  }

  // Validate required fields
  if (formData[field.name] === undefined || formData[field.name] === null || formData[field.name] === "") {
    errors[field.name] = "Campo obligatorio";
  }
};